"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { tbSelectionBtnClicked } from "Actions/Table/TableToolBarActions";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { Messages } from "Messages";
import { System } from "Constants/objects";

var DeselectAllProps =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(DeselectAllProps, _BaseToolbarButtonPro);

  function DeselectAllProps(_ref) {
    var _this;

    var formUUID = _ref.formUUID,
        isContextMenu = _ref.isContextMenu;

    _classCallCheck(this, DeselectAllProps);

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    var props = _objectSpread({
      isContextMenu: isContextMenu,
      text: Messages.Controls.DeselectAll,
      hint: Messages.Controls.DeselectAllHint,
      iconType: 'fontawesome:select-all-button far fa-square',
      elementAttr: {
        'class': System.TOOLBAR_BTN_CLASSES.DESELECT
      },
      onClick: function onClick() {
        _this.UUID = _this._isContextMenu ? _this._props.UUID : _this._props.options.UUID;
        tbSelectionBtnClicked({
          formUUID: _this.UUID,
          selection: false
        });
      }
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DeselectAllProps).call(this, props));
    isContextMenu ? _this._props.UUID = formUUID : _this._props.options.UUID = formUUID;
    return _this;
  }

  return DeselectAllProps;
}(BaseToolbarButtonProp);

_defineProperty(DeselectAllProps, "create", function (options) {
  return new DeselectAllProps(options).props();
});

export { DeselectAllProps as default };